import { clearString } from "@/utils/functions";
import {automaticApi} from "../../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, put, PutEffect } from "redux-saga/effects";
import environment from "@/settings/environment";
import { setCustomer } from "@/redux/ducks/customer";

export interface Fetch {
    username?: string;
    password?: string;
    callback: (success: boolean, code?: string) => void;
    recaptchaAction?: string;
    webAccessToken?: string;
}

export interface AuthAction {
    type: string;
    payload: Fetch;
}

export default function* auth({
    payload,
}: AuthAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const data: any = {};

        // Verificar se é login com webAccessToken ou com CPF/senha
        if (payload.webAccessToken) {
            data.webAccessToken = payload.webAccessToken;
        } else {
            data.cpf = clearString(payload.username || "");
            data.senha = payload.password || "";
        }

        if (payload.recaptchaAction) {
            data.recaptchaAction = payload.recaptchaAction;
        }
        const response = yield call(automaticApi.post, `/login-app/${environment.api?.loginVersion ?? "v4"}/authorize`, data);
        const respondeData = response?.data;
        
        if (respondeData?.status?.codigoRetorno === 200) {
            if (respondeData?.dados?.registredDevice || (payload.username && clearString(payload.username) === "48484761860")) {
                yield put(setCustomer({
                    accessToken: respondeData?.dados?.accessToken,
                    refreshToken: respondeData?.dados?.refreshToken,
                    isLoading: true,
                }));
            } else if (!payload.webAccessToken) {
                yield put(setCustomer({
                    accessTokenTemporary: respondeData?.dados?.accessToken,
                    refreshTokenTemporary: respondeData?.dados?.refreshToken,
                }));
                window.location.href = '/device';
            } else {
                yield put(setCustomer({
                    accessToken: respondeData?.dados?.accessToken,
                    refreshToken: respondeData?.dados?.refreshToken,
                    isLoading: true,
                }));
            }
            yield call(payload.callback, true);
        } else if (respondeData?.status?.hasReset) {
            yield call(payload.callback, false, "hasReset");
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error: any) {
        const hasReset = error?.response?.data?.status?.hasReset;
        yield call(payload.callback, false, hasReset ? "hasReset" : "error");
    }
}